import { parseHyperlinks } from "@/lib/hyperlinkUtils";

interface HyperlinkRendererProps {
  text: string;
  className?: string;
}

const HyperlinkRenderer = ({ text, className }: HyperlinkRendererProps) => {
  const parts = parseHyperlinks(text);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (typeof part === "string") {
          return <span key={index}>{part}</span>;
        }
        return (
          <a
            key={index}
            href={part.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
            onClick={(e) => e.stopPropagation()}
          >
            {part.text}
          </a>
        );
      })}
    </span>
  );
};

export default HyperlinkRenderer;
